<template>
  <div class="query-header">
    <el-row
      :gutter="20"
      type="flex"
      justify="start"
      class="el-row-root"
    >
      <el-col
        :lg="3"
        :md="5"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          v-model="status"
          placeholder="授权状态"
          style="width: 100%"
          class=""
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="3"
        :md="5"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          placeholder="授权产品"
          v-model="productType"
          style="width: 100%"
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in productList"
            :key="index"
            :label="`${item.productName} (${item.productCode})`"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="3"
        :md="5"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          placeholder="类型"
          v-model="type"
          style="width: 100%"
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in authtypes"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="3"
        :md="5"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-input
          clearable
          placeholder="客户姓名/手机"
          v-model="customerInfo"
          @keyup.enter="toQuery"
        >
        </el-input>
      </el-col>
      <el-col
        :lg="3"
        :md="5"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-input
          clearable
          placeholder="推荐人姓名"
          v-model="recommenInfo"
          @keyup.enter="toQuery"
        >
        </el-input>
      </el-col>
      <vs-button
        type="info"
        v-if="isAuth('auth:management:list')"
        class="search-btn btn box-item"
        @click="searchHandle"
      >查询</vs-button>
      <vs-button
        v-if="isAuth('auth:management:save')"
        class="add-btn btn box-item"
        @click="addHandle"
      >新增</vs-button>
      <vs-button
        v-if="isAuth('auth:management:batchCreate')"
        class="add-btn btn box-item"
        @click="uploadHandle"
      >批量导入</vs-button>
      <vs-button
        v-if="isAuth('auth:management:list')"
        :disabled="selected.length < 1"
        class="add-btn box-item"
        @click="exportHandle"
      >导出选中</vs-button>
      <vs-button
        v-if="isAuth('auth:management:delete')"
        :disabled="selected.length < 1"
        class="mutil-btn box-item"
        @click="deleteHandle"
      >批量删除</vs-button>
    </el-row>
  </div>
</template>

<script>
import  { mapGetters } from 'vuex';
export default {
  name: "queryHeader",
  props: {
    selected: {
      type: Array,
      default(){
        return [];
      }
    },
    productList:{
      type: Array,
      default(){
        return []
      }
    }
  },
  data() {
    return {
      status: '',
      statusList: [
        {label: '有效',value: 1},
        {label: '失效 ',value: 0},
      ],
      productType: '',
      customerInfo: '',
      recommenInfo: '',
      type:'',
      authtypes:[
        {value:1,label:"普通码"},
        {value:2,label:"试用码"},
        {value:3,label:"每日授权码"}
      ],
      category: '',
      categoryList:[
        {key:'yanbao',name:'研报'},
        {key:'celve',name:'策略'},
        {key:'ask',name:'问答'},
        {key:'help',name:'帮助中心'},
        {key:'tech',name:'交易技术'},
        {key:'analisy',name:'技术分析'},
      ],
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile']),
  },
  created(){
  },
  methods: {
    uploadHandle(){
      this.$emit('upload');
    },
    toQuery(){
      this.$emit('toQuery');
    },
    searchHandle(){
      this.toQuery();
    },
    addHandle(){
      this.$emit('add');
    },
    deleteHandle(){
      this.$emit('delete');
    },
    exportHandle(){
      this.$emit('export')
    },
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .el-row-root {
    flex-wrap: wrap;
    align-items: center;
  }
  .el-col-el {
    min-width: 0;
  }
  .header-sub-item {
    width: 100%;
  }
  .box-item {
    margin-left: 8px;
    flex-shrink: 0;
  }
}

@media screen and (max-width: 768px) {
  .query-header {
    .el-row-root {
      margin-left: 0!important;
      margin-right: 0!important;
    }
    .el-col-el {
      width: 100%;
      margin-bottom: 10px;
      padding-left: 0!important;
      padding-right: 0!important;
    }
    .box-item {
      min-width: 96px;
      margin-left: 0;
      margin-right: 8px;
      margin-bottom: 10px;
    }
  }
}
</style>
